import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
// import { Link } from 'react-router-dom';
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  makeStyles,
} from '@material-ui/core/';
import FormContainer from '../Components/FormContainer/FormContainer';
import CheckoutSteps from '../Components/CheckoutStep/CheckoutSteps';
import { saveShippingAddress } from '../Actions/cartAction';
// import { addToShipping } from 'Actions/shippingAction';
import * as routes from '../Constants/routes';
// import { interpolate } from '../utils/string';
// import { shipping } from 'Actions/shippingAction';

// import { TextField, Button } from '@material-ui/core/';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  prgressColor: {
    color: '#000000',
  },
}));


const Shipping = ({ history }) => {
  const cart = useSelector((state) => state.cart);
 // const [qty, setQty] = useState(1);
  // const shippingData = useSelector((state) => state.Shipping);
  // const shipping = useSelector((state) => state.shipping);
  // const { shipping } = shipping;
  
  const { shippingAddress, cartItems } = cart;
 

  const [area, setArea] = useState(shippingAddress.area);
  const [road, setRoad] = useState(shippingAddress.road);
  const [landmark, setLandMark] = useState(shippingAddress.landmark);
  const [building, setBuilding] = useState(shippingAddress.building);
  const [floorNo, setFloorNo] = useState(shippingAddress.floorNo);
  const [houseNo, setHouseNo] = useState(shippingAddress.houseNo);

  if (!cartItems.length) {
    history.push({
      pathname: routes.HOME,
    });
  }


  const dispatch = useDispatch();
  

  const classes = useStyles();

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(saveShippingAddress({ area, road, landmark, building, floorNo, houseNo }));
    history.push({
      pathname: routes.PLACE_ORDER,
    });
  };
  return (
    <FormContainer>
      <CheckoutSteps step1 />
      <h1>Shipping</h1>
      
      <Form onSubmit={submitHandler}>
      <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">Area</InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  onChange={(e) => setArea(e.target.value)}
                  label="Area"
                  value={area}
                >
                  <MenuItem value="Kawangware">Kawangware</MenuItem>
                  <MenuItem value="Congo">Congo</MenuItem>
                  <MenuItem value="Amboseli">Amboseli</MenuItem>
                  <MenuItem value="Lavington">Lavington</MenuItem>
                  <MenuItem value="Yaya">Yaya</MenuItem>
                  <MenuItem value="Hurlingham">Hurlingham</MenuItem>
                  <MenuItem value="Kitengela">Kitengela</MenuItem>
                </Select>
              </FormControl>

        <TextField
          variant="outlined"
          type="text"
          margin="normal"
          required
          fullWidth
          id="road"
          label="Enter Road"
          name="road"
          autoComplete="road"
          autoFocus
          value={road}
          onChange={(e) => setRoad(e.target.value)}
        />

        <TextField
          variant="outlined"
          type="text"
          margin="normal"
          required
          fullWidth
          id="landmark"
          label="Enter Land mark"
          name="land mark"
          autoComplete="land mark"
          autoFocus
          value={landmark}
          onChange={(e) => setLandMark(e.target.value)}
        />

        <TextField
          variant="outlined"
          type="text"
          margin="normal"
          required
          fullWidth
          id="building"
          label="Enter Estate and/or Building"
          name="building"
          autoComplete="building"
          autoFocus
          value={building}
          onChange={(e) => setBuilding(e.target.value)}
        />
        <TextField
          variant="outlined"
          type="text"
          margin="normal"
          required
          fullWidth
          id="floorNo"
          label="Enter Floor Number"
          name="floorNo"
          autoComplete="floorNo"
          autoFocus
          value={floorNo}
          onChange={(e) => setFloorNo(e.target.value)}
        />
         <TextField
          variant="outlined"
          type="text"
          margin="normal"
          required
          fullWidth
          id="houseNo"
          label="Enter House Number"
          name="houseNo"
          autoComplete="houseNo"
          autoFocus
          value={houseNo}
          onChange={(e) => setHouseNo(e.target.value)}
        />

        <Button type="submit" variant="contained" color="primary" fullWidth>
          Continue
        </Button>
      </Form>
    </FormContainer>
  );
};

export default Shipping;
